import subscriptions from "conf/subscriptions"
export default {
    node: "node",
    search: "searchText",
    doSearch: "doSearch",
    closeLightbox: "closeLightbox",
    ...subscriptions,
}
